import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function DragIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.75 8.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0-5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 10.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m4.5-5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0-5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 10.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5" /></svg>
  );
}

export default DragIcon;
